import * as Yup from 'yup'

export const schemaNotification = (t: (key: string) => string) => ({
  title: Yup.string().required(t('requiredMessage')),
  type: Yup.string().required(t('requiredMessage')),
  content: Yup.string().required(t('requiredMessage')),
})
